import { render, staticRenderFns } from "./PostItem.vue?vue&type=template&id=ba29d78e&scoped=true&"
import script from "./PostItem.vue?vue&type=script&lang=js&"
export * from "./PostItem.vue?vue&type=script&lang=js&"
import style0 from "./PostItem.vue?vue&type=style&index=0&id=ba29d78e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba29d78e",
  null
  
)

export default component.exports